<style lang="less">
	#pop-out-menu{
		position: absolute;
		right: 100px;
		bottom: -5%;
		z-index: 1;
	}
</style>
<template>
	<v-card class="mb-5" style="position: relative; min-height: 400px" >
		<v-expansion-panels flat focusable>
			<v-expansion-panel v-for="(element, index) in elements" :key="element.name" :index="index">
				<v-expansion-panel-header> 
					<div style="display: inline-block; width: 40px">

						<v-menu>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" small fab :color="getColor(element)">	
									<v-icon color="white">{{questionTypes[element.type].icon}}</v-icon>
								</v-btn>
							</template>

							<v-list dense>
								<v-list-item @click="$emit('moveQuestion', element, 'up')">
									<v-list-item-title>Move Up</v-list-item-title>
								</v-list-item>
								<v-list-item @click="$emit('moveQuestion', element, 'down')">
									<v-list-item-title>Move Down</v-list-item-title>
								</v-list-item>
								<v-list-item @click="$emit('deleteQuestion', element)">
									<v-list-item-title >Delete question</v-list-item-title>
								</v-list-item>
								<v-list-item @click="$emit('addToQuestionLibrary', element)">
									<v-list-item-title >Add To Question Library</v-list-item-title>
								</v-list-item>
								<v-list-item @click="copyQuestion(element)">
									<v-list-item-title >Copy Question</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>


					</div>
					<div style="display: inline-block;  width: 100%" class="pl-2">
						{{element.title}}
					</div>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
							<TextInputWithMergeField label="Title" :object="element" objectKey="title" :elements="elementsAfter( index )"></TextInputWithMergeField>
							<component v-bind:is="questionTypes[element.type].component" v-bind="questionTypes[element.type].props" :question="element"></component>
							<StandardOptions :question="element"></StandardOptions>
							<VisibleIf v-if="!element.hidden" :question="element" :elements="elementsAfter( index )" v-on:save="saveConditions"></VisibleIf>
					</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>	
		<v-card v-if="showQuestionSelection" id="pop-out-menu">
			<v-list>
				<v-list-item-group v-model="item">
					<v-list-item  v-for="(questionType, key, i) in questionTypes" :key="i" @click="newQuestion(key)">
						<v-list-item-avatar :color="colors[i]" v-if="questionType.icon">
							<v-icon color="white">{{questionType.icon}}</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title v-html="questionType.name"></v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
				<v-list-item-group>
					<v-list-item @click="questionLibraryDialog = 1">
						<v-list-item-avatar color="primary" >
							<v-icon color="white">mdi-folder-star</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title>Saved Questions</v-list-item-title>
						</v-list-item-content>
					</v-list-item>					
				</v-list-item-group>
			</v-list>
		</v-card>
		<v-dialog v-model="questionLibraryDialog" >
			<QuestionLibrary :questionTypes="questionTypes" 
			v-on:cancel="questionLibraryDialog = false;" v-on:insert="insertQuestion" ></QuestionLibrary>
		</v-dialog>					
		<v-btn color="green" dark absolute bottom right fab @click="showQuestionSelection = !showQuestionSelection">
			<v-icon v-if="showQuestionSelection">mdi-close</v-icon>
			<v-icon v-else>mdi-plus</v-icon>
		</v-btn>				
	</v-card>
</template>

<script>

import Vuex from 'vuex';
import VisibleIf from "../edits/editorFields/VisibleIf";
import StandardOptions from "../edits/editorFields/StandardOptions";
import TextInputWithMergeField from "../edits/editorFields/TextInputWithMergeField.vue";

export default {
	name: 'SurveyEditor',
	props: {
		elements: {type: Object}
	},
	components: {
		FieldText:  () => import("../edits/editorFields/FieldText"),
		FieldHTML: () => import("../edits/editorFields/FieldHTML"),
		FieldChoices: () => import("../edits/editorFields/FieldChoices"),
		FieldMatrix: () => import("../edits/editorFields/FieldMatrix"),
		QuestionLibrary: () => import("../edits/editorFields/QuestionLibrary"),
		VisibleIf: VisibleIf,
		StandardOptions: StandardOptions,
		TextInputWithMergeField: TextInputWithMergeField,
	},
	computed: {
		...Vuex.mapState({
			colors: state => state.settings.colors 
		}), 
	},
	data: () => ({
		tab: "editor",
		questionTab: "edit",
		showQuestionSelection: false,
		questionLibraryDialog: false,
		questionTypes: {
			text: {
				component: "FieldText",
				name: 'Text Question',
				props: {  },
				icon: "mdi-text-short",
			},
			html: {
				component: "FieldHTML",
				name: 'HTML Element',
				props: {  },
				icon: "mdi-xml",
			},
			comment: {
				component: "FieldText",
				name: 'Comment',
				props: {  },
				icon: "mdi-text",
			},
			dropdown: {
				component: "FieldChoices",
				name: 'Select',
				props: { 'key': 'choices' },
				icon: "mdi-arrow-down-drop-circle",
			},
			radiogroup: {
				component: "FieldChoices",
				name: 'Radio group',
				props: { 'key': 'choices' },
				icon: "mdi-radiobox-marked"
			},
			checkbox: {
				component: "FieldChoices",
				name: 'Checkboxes',
				props: { 'key': 'choices' },
				icon: "mdi-checkbox-multiple-marked-circle"
			},
			matrix: {
				component: "FieldMatrix",
				name: 'Matrix',
				props: {  },
				icon: "mdi-table",
			}
		}
	}),
	methods: {
		generateId(){
			let randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
			let uniqid = randLetter + Date.now();
			return randLetter + uniqid;
		},
		getColor(question){
			if( question.hidden ){
				return "grey"
			}
			return this.colors[ Object.keys(this.questionTypes).indexOf( question.type ) ]
		},

		newQuestion(type){
			let newQuestion = {
				type: type,
				title: 'New question',
				name: this.generateId()
			}
			this.$emit( "questionAdded", newQuestion );
			this.showQuestionSelection = false
		},
		copyQuestion(question){
			let newQuestion = {...question};
			newQuestion.name = this.generateId();
			newQuestion.title += " (Copy)";
			this.$emit( "questionAdded", newQuestion );
		},
		insertQuestion(question){
			this.$emit( "questionAdded", question );
			this.showQuestionSelection = false;
		},
		elementsAfter(index){
			let result = [...this.elements].splice( 0, index );
			return result;
		}, 
		saveConditions(conditions, question){
			question.visibleIf = conditions; 
		}
	},
	watch: {
		questionLibraryDialog(){
			this.showQuestionSelection = false
		}
	}
};

</script>
